import { lazy, Suspense, type ComponentProps } from "react";
import remarkGfm from "remark-gfm";

const ReactMarkdown = lazy(() => import("react-markdown"));

export function Markdown({
  children,
  className = "",
}: {
  children: string;
  className?: string;
}) {
  return (
    <div className={`markdown-content ${className}`}>
      <Suspense
        fallback={
          <span
            role="status"
            className="loading-block bg-ink/10 block h-20 w-full"
          >
            <span className="sr-only">Cargando contenido…</span>
          </span>
        }
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{ p: Paragraph }}
        >
          {children}
        </ReactMarkdown>
      </Suspense>
    </div>
  );
}

type ParagraphNode = {
  children: Array<{ type: string; tagName?: string; value?: string }>;
};

// A paragraph made only of bold text is a subheading in lesson descriptions.
function Paragraph({
  node,
  ...props
}: ComponentProps<"p"> & { node?: ParagraphNode }) {
  const content = (node?.children ?? []).filter(
    (child) => !(child.type === "text" && !child.value?.trim()),
  );
  const subheading =
    content.length === 1 &&
    content[0]?.type === "element" &&
    content[0].tagName === "strong";
  return (
    <p {...props} className={subheading ? "markdown-subheading" : undefined} />
  );
}
